export const bannerDate = {
  bgClass: 'duplex-scanning', // класс к bg
  date: null,
  title: 'Дуплексное сканирование артерий головы и шеи от А до Я. \n' +
    'Современные подходы к диагностике и интерпретации результатов. \n' +
    'Важнейшие диагностические проблемы и пути их решения', // заголовок если нет то убрать совсем или null
  address: '',
  online: false,
  onlineOnly: false,// будет проводится онлайн на сайте или нет если нет то убрать(закомментить) совсем или (null || false)
  linkEvent: '/lections/4086',
  spciality: 'Акушерство и гинекология',
  gragient: 'hsla(0,0%,100%,0.1)'
  // ссылка на кнопку подробнее  если нет то убрать(закомментить) совсем или (null || false)
  // author: {
  //     show: false,
  //     name: "Вальский Дан (Dan V. Valsky)",
  //     ava: "/upload/images/lectors/thumb_397.jpg",
  //     prof: null,
  // } // автор если нет то убрать(закомментить) совсем или null
};
